/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useSelector, useDispatch } from 'react-redux';
import { Loader } from 'modules/common/components';
import { selectLoader } from 'modules/visual-filter/selectors';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Button,
  FormControlLabel,
  FormControl,
  Switch,
} from '@mui/material';
import { withTheme } from '@emotion/react';
import { Formik } from 'formik';
import { selectNotification } from 'modules/common/notifications/selectors';
import { notificationActions } from 'modules/common/notifications/slice';
import { systemActions } from 'modules/system/slice';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import TOAST_TYPES from 'modules/common/constants/toast-types';
import ERROR_TYPES from 'modules/common/constants/error-types';
import AddSystemNotice from '../add-system-notice-view';

/**
 * Sync component to sync all databricks, breakdown, currency data
 * @param {*} param0
 * @returns
 */
const SystemView = () => {
  const dispatch = useDispatch();
  //
  const loading = useSelector(selectLoader);
    const notification = useSelector(selectNotification);
  //
  const initialValues = {
    forceSync: false,
  };
  const onSubmitSyncDatabricksData = async (values) => {
    const query = `forceSync=${values.forceSync.toString()}`;
    dispatch(systemActions.syncDatabricksData({ query }));
  };
  //
  const onSubmitBreakdownData = async () => {
    dispatch(systemActions.syncBreakdownData());
  };
  //
  const onSubmitSynCurrencyData = async () => {
    dispatch(systemActions.syncCurrencyData());
  };
  //
    useEffect(() => {
      if (notification?.isEnabled && notification?.type === ERROR_TYPES.SUCCESS) {
        toast(notification?.message, { type: TOAST_TYPES.SUCCESS });
        dispatch(notificationActions.resetNotification());
      }
    }, [notification]);
    //
  return (
    <Loader loading={loading}>
      <Card>
        <CardContent>
          <Grid container direction="row" justifyContent="space-between">
            <Typography variant="h3">Sync</Typography>
            <Formik initialValues={initialValues} onSubmit={onSubmitSyncDatabricksData}>
              {({ handleBlur, handleChange, handleSubmit, isSubmitting, values }) => (
                <form noValidate onSubmit={handleSubmit}>
                  <FormControl sx={{ paddingTop: 3, paddingBottom: 3 }}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="forceSync"
                          checked={values?.forceSync}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      }
                      label="Force Sync"
                      sx={{
                        width: 'fit-content',
                        height: 10,
                      }}
                    />
                  </FormControl>
                  <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
                    Sync Databricks Data
                  </Button>
                </form>
              )}
            </Formik>
            <Button variant="contained" color="primary" onClick={() => onSubmitBreakdownData()}>
              Sync Breakdown Data
            </Button>
            <Button variant="contained" color="primary" onClick={() => onSubmitSynCurrencyData()}>
              Sync Currency Data
            </Button>
          </Grid>
        </CardContent>
      </Card>
      <br />
      <Card>
        <CardContent>
          <Grid container direction="row" justifyContent="space-between">
            <Typography variant="h3">Announcements</Typography>
            <AddSystemNotice />
          </Grid>
        </CardContent>
      </Card>
    </Loader>
  );
};
//
export default withTheme(SystemView);
